import { styled } from "@mui/system";

export const HeaderWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  width: "99%",
  padding: "17px 16px 17px 16px",
  justifyContent: "space-between",
  alignItems: "flex-start",
  fontSize: "14px",
  [theme.breakpoints.down(500)]: {
    flexDirection: "column",
    gap: "8px",
  },
}));

export const HeaderHello = styled("span")({
  color: "#FC4C4C",
});

export const AnnouncementWrapper = styled("div")({
  display: "flex",
  width: "100%",
  padding: "0px 16px 0px 16px",
  alignItems: "flex-start",
  alignSelf: "stretch",
});

export const GuestBannerWrapper = styled("div")({
  display: "flex",
  width: "100%",
  padding: "0px 16px 0px 16px",
  alignItems: "flex-start",
  alignSelf: "stretch",
  marginBottom: "24px",
});

export const YourCryptoPanel = styled("div")(({ theme }) => ({
  display: "flex",
  padding: "16px",
  flexDirection: "column",
  gap: "16px",
  alignSelf: "stretch",
  borderRadius: "16px",
  border: `1px solid ${theme.palette.secondary.contrastText}`,
  background: theme.palette.background.paper,
}));

export const NewsPanel = styled("div")(({ theme }) => ({
  display: "flex",
  padding: "16px",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "16px",
  alignSelf: "stretch",
  borderRadius: "16px",
  border: `1px solid ${theme.palette.secondary.contrastText}`,
  background: theme.palette.background.paper,
}));

export const TransactionsPanel = styled("div")(({ theme }) => ({
  display: "flex",
  padding: "16px",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "16px",
  alignSelf: "stretch",
  borderRadius: "16px",
  border: `1px solid ${theme.palette.secondary.contrastText}`,
  background: theme.palette.background.paper,
  fontSize: "14px",
}));

// DEKSTOP STYLES //
export const DGridWrapper = styled("div")({
  display: "flex",
  width: "100%",
  height: "100%",
  padding: "0px 16px",
  paddingBottom: "32px",
  justifyContent: "center",
  alignItems: "center",
  gap: "12px",
  flexShrink: 0,
});

export const DLeftColumn = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "12px",
  flex: "1 0 0",
  alignSelf: "stretch",
});

export const DRightColumn = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "12px",
  alignSelf: "stretch",
});

export const DBalancePanel = styled("div")(({ theme }) => ({
  display: "flex",
  padding: "16px",
  paddingBottom: "32px",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "16px",
  alignSelf: "stretch",
  borderRadius: "16px",
  border: `1px solid ${theme.palette.secondary.contrastText}`,
  background: theme.palette.background.paper,
}));

export const DReferralPanel = styled("div")(({ theme }) => ({
  width: "332px",
  padding: "16px",
  borderRadius: "16px",
  border: `1px solid ${theme.palette.secondary.contrastText}`,
  background:
    "radial-gradient(circle at 80%, rgba(254, 176, 176, 0.2), rgba(255, 255, 255, 0.4) 60%)",
}));

export const DSummaryPanel = styled("div")(({ theme }) => ({
  display: "flex",
  padding: "16px",
  width: "100%",
  height: "232px",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "16px",
  borderRadius: "16px",
  border: `1px solid ${theme.palette.secondary.contrastText}`,
  background: theme.palette.background.paper,
}));

// TABLET STYLES //
export const TGridWrapper = styled("div")({
  display: "flex",
  height: "100%",
  padding: "0px 16px",
  paddingBottom: "16px",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  gap: "12px",
  flexShrink: 0,
  alignSelf: "stretch",
});

export const TBalancePanel = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  alignSelf: "stretch",
  padding: "16px",
  paddingBottom: "32px",
  gap: "16px",
  borderRadius: "16px",
  border: `1px solid ${theme.palette.secondary.contrastText}`,
}));

export const TReferralPanel = styled("div")(({ theme }) => ({
  height: "153px",
  alignSelf: "stretch",
  padding: "16px",
  borderRadius: "16px",
  border: `1px solid ${theme.palette.secondary.contrastText}`,
  background:
    "radial-gradient(circle at 80%, rgba(254, 176, 176, 0.2), rgba(255, 255, 255, 0.4) 60%)",
}));

export const TSummaryPanel = styled("div")(({ theme }) => ({
  display: "flex",
  padding: "16px",
  width: "100%",
  flexDirection: "column",
  alignItems: "flex-start",
  alignSelf: "stretch",
  gap: "16px",
  borderRadius: "16px",
  border: `1px solid ${theme.palette.secondary.contrastText}`,
  background: theme.palette.background.paper,
}));
